import genderEnum from './genderEnum'
import nationEnum from './nationEnum'
import degreeEnum from './degreeEnum'
import academicDegreeEnum from './academicDegreeEnum'
import politicalLandscapeEnum from './politicalLandscapeEnum'
import staffTypeEnum from './staffTypeEnum'
import formStatusEnum from './formStatusEnum'
import nodeEnum from './nodeEnum'
import hrAuditOpinionEnum from './hrAuditOpinionEnum'
import hrApprovalOpinionEnum from './hrApprovalOpinionEnum'
import jobTitleEnum from './jobTitleEnum'
import skilljobEnum from './skilljobEnum'
import postTypeEnum from './postTypeEnum'
import postLevelEnum from './postLevelEnum'
import maritalStatusEnum from './maritalStatusEnum'
import healthStatusEnum from './healthStatusEnum'
import residenceTypeEnum from './residenceTypeEnum'
import educationLevelEnum from './educationLevelEnum'
import roleEnum from './roleEnum'
import videoFileExtEnum from './videoFileExtEnum'
import positionStatusEnum from './positionStatusEnum'
import fileUploadTypeEnum from './fileUploadTypeEnum'
import isLeaderEnum from './isLeaderEnum'

export default {
    genderEnum,
    nationEnum,
    degreeEnum,
    academicDegreeEnum,
    politicalLandscapeEnum,
    staffTypeEnum,
    formStatusEnum,
    nodeEnum,
    hrAuditOpinionEnum,
    hrApprovalOpinionEnum,
    jobTitleEnum,
    skilljobEnum,
    postTypeEnum,
    postLevelEnum,
    maritalStatusEnum,
    healthStatusEnum,
    residenceTypeEnum,
    educationLevelEnum,
    roleEnum,
    videoFileExtEnum,
    positionStatusEnum,
    fileUploadTypeEnum,
    isLeaderEnum,
}